export const Bio = {
  name: "Dipak Mundhe",
  roles: [
    "Full Stack Developer",
    "FrontEnd Developer",
    "Programmer",

  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/dsmundhe",
  resume:
    "https://beige-constancy-16.tiiny.site/",
  linkedin: "https://www.linkedin.com/in/dipak-samadhan-mundhe-b2301425b/",
  twitter: "https://twitter.com/",
  insta: "https://www.instagram.com/ds.mundhe28/",
  facebook: "https://www.facebook.com/dipak.mundhe.372",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },


    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:"https://i.pinimg.com/736x/06/ae/80/06ae800957fd7efabe894de3d1c0611b.jpg",
      },

      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },

      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },

    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://i.pinimg.com/736x/1a/8a/19/1a8a19e550676f7728f3f8441e9b7684.jpg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },

      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://yt3.googleusercontent.com/X-rhKMndFm9hT9wIaJns1StBfGbFdLTkAROwm4UZ3n9ucrBky5CFIeeZhSszFXBgQjItzCD0SA=s900-c-k-c0x00ffffff-no-rj",
      },

    ],
  },
];

export const experiences = [
  {
    id: 0,
 img:"https://media.licdn.com/dms/image/v2/C4E0BAQGs7EmZ0yQMpQ/company-logo_200_200/company-logo_200_200/0/1661493099915?e=2147483647&v=beta&t=q1FaDtUzcTHCfhVD2ZOVUAonY0kXQeYW3k0PjSLw1Zg",
    role: "Frontend Developer Intern",
    company: "InternPey",
    date: "Aug 2023 - July 2023",
    desc: "Working on Frontend projects",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
       "HTML",
      "CSS",
      "JavaScript",

    ],
   },
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/D560BAQHDmIfYA5sY7w/company-logo_200_200/company-logo_200_200/0/1685777115831?e=2147483647&v=beta&t=BrbAEJ0lciXi69uR0VBVOdOGHno8XzclslDmxrVYaNI",
    role: "Frontend Engineer Intern",
    company: "CodeSoft",
    date: "June 2023 - july 2023",
    desc: "Working on the frontend of the web application using ReactJS, Redux",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
       "HTML",
      "CSS",
      "JavaScript",
    ],
   },
  
  
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRDW60MvDx-W5U57bFADz9L28P8ThTT8J0zI2Q12mGU7QY4WjBdzh3Bd47KRWFf6ToNNRI&usqp=CAU",
    school: "Yeshwantrao chavhan College of Engineering ,Nagpur",
    date: "Oct 2022 - Sep 2026",
    grade: "8.56 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Yeshwantrao chavhan College of Engineering Nagpur I have completed 4 semesters and have a CGPA of 8.56. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering IOT",
  },
  {
    id: 1,
    img: "https://thumbs.dreamstime.com/z/education-badge-logo-design-university-high-school-emblem-education-badge-logo-design-university-high-school-emblem-151924849.jpg",
    school: "Sharad Pawar vidyalay Warud",
    date: "Apr 2020 - Apr 2022",
    grade: "76.33%",
    desc: "I completed my class 12 high school education , where I studied Science with Computer Science.",
    degree: "ISC(XII), Science with Computer",
  },
  {
    id: 2,
    img: "https://thumbs.dreamstime.com/z/education-badge-logo-design-university-high-school-emblem-education-badge-logo-design-university-high-school-emblem-151924849.jpg",
    school: "Sharad Pawar vidyalay Warud",
    date: "Apr 2018 - Apr 2019",
    grade: "77.80%",
    desc: "I completed my class 10 education   where I studied Science with Computer Application.",
    degree: "ICSC(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 1,
    title: "ShopX",
    date: "Aug 2023 - Present",
    description:
      "Designed and developed ShopX, an eCommerce web application that allows users to browse, search, and purchase products. The app features product categories, a shopping cart system, and user authentication. Users can add products to their cart, view detailed product information, and manage their orders. Future plans include integrating payment options and real-time delivery tracking.",
    image:
      "https://i.pinimg.com/564x/f1/ca/4a/f1ca4a2b4143a4ce875b20261bc91a4c.jpg",
    tags: [
      "React.js",
      "MongoDB",
      "Node.js",
      "Express.js",
      "Redux",
      "Tailwind CSS",
    ],
    category: "web app",
    github: "https://github.com/dsmundhe/my-projects",
    webapp: "https://ecommercedm.netlify.app/",
  },
  {
    id: 9,
    title: "HostelDekho",
    date: "Jun 2023 - Jul 2023",
    description:
      "HostelDekho is a web application designed to help users find and book hostels by city. It offers a user-friendly interface for hostel listings, detailed views, and booking functionality, streamlining the accommodation search process for travelers. Built using the MERN stack, the app includes features like real-time availability, filtering options, and secure booking.",
    image:
      "https://i.pinimg.com/736x/ba/78/c4/ba78c47fbec1cd471d1bf4d1b4fbb335.jpg",
    tags: [
      "React.js",
      "Redux",
      "MongoDB",
      "Node.js",
      "Express.js",
      "JavaScript",
      "CSS",
      "HTML",
    ],
    category: "web app",
    github: "https://github.com/dsmundhe/my-projects",
    webapp: "https://hosteldekho.netlify.app/",
  },
  {
    id: 0,
    title: "The Career Company",
    date: "Jul 2023 - Aug 2023",
    description:
      "Developed a full-stack web application that provides mentorship and growth analysis through tests and counseling services. Users can join as trainees or mentors to engage in skill development and career growth. Implemented real-time chat functionality, user authentication using Jwt Auth, and a responsive user interface with React JS. Collaborated with a team following agile methodologies to enhance team communication and optimize development processes.",
    image:
      "https://i.pinimg.com/originals/8f/b1/ec/8fb1ecd681092adddc0f34240a56bc1e.gif",
    tags: [
      "React.js",
      "MongoDB",
      "Node.js",
      "Express.js",
      "Redux",
      "WebSocket",
      "JWT Auth",
    ],
    category: "web app",
    github: "https://github.com/dsmundhe/my-projects",
    webapp: "https://web-wizards-36.netlify.app/",
  },
 
  {
    id: 2,
    title: "GeminiTalk",
    date: "Aug 2023 - Present",
    description:
      "Developed a chatbot application using Gemini APIs, focusing on providing real-time conversational AI responses. Implemented a typing effect that displays bot responses word by word, with a seamless chat interface where previous questions and answers are retained in a conversational format. Future enhancements include improved AI responses and integration with external APIs for more dynamic interactions.",
    image:
      "https://i.pinimg.com/564x/3a/26/a3/3a26a3f4bcc557a08fd3e2e16fe2344c.jpg",
    tags: ["React", "Node.js", "Express.js", "Gemini API", "Chatbot", "CSS"],
    category: "AI/Chatbot",
    github: "https://github.com/dsmundhe/my-projects",
    webapp: "https://chatai-dm.netlify.app/",
  },
  {
    id: 3,
    title: "Spotify Clone",
    date: "Sep 2023 - Present",
    description:
      "Developed a Spotify Clone web application, replicating the core features of Spotify. Users can search for songs, create playlists, and listen to music. Integrated Spotify's public API to fetch real-time data, and implemented a user-friendly interface using React. The app features seamless playback, playlist management, and user authentication using OAuth.",
    image:
      "https://i.pinimg.com/564x/e4/ea/c3/e4eac3becaca0650fbc80b1af124adde.jpg",
    tags: ["React", "CSS"],
    category: "web app",
    github: "https://github.com/dsmundhe/",
    webapp: "https://spotifyclone.netlify.app/",
  },
 
 
];


export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
